export const blogTranslations = {
    BLOG_TITLE: {
        en: "Blog",
        es: "Blog",
        pt: "Blog"
    },
    BLOG_SUBTITLE: {
        en: "News, stories, and updates from the developer.",
        es: "Noticias, historias y novedades del desarrollador.",
        pt: "Notícias, histórias e novidades do desenvolvedor."
    },

    // Post: Support Independent Dev
    BLOG_SUPPORT_TITLE: {
        en: "Support the Project: Independent Development",
        es: "Apoya el Proyecto: Desarrollo Independiente",
        pt: "Apoie o Projeto: Desenvolvimento Independente"
    },
    BLOG_SUPPORT_P1: {
        en: "Hi! I'm xpolz, the independent developer behind ConfigStrike. This project started with a simple idea: creating the best configuration tools for the CS2 community.",
        es: "¡Hola! Soy xpolz, el desarrollador independiente detrás de ConfigStrike. Este proyecto nació de una idea simple: crear las mejores herramientas de configuración para la comunidad de CS2.",
        pt: "Olá! Eu sou o xpolz, o desenvolvedor independente por trás do ConfigStrike. Este projeto começou com uma ideia simples: criar as melhores ferramentas de configuração para a comunidade CS2."
    },
    BLOG_SUPPORT_P2: {
        en: "Keeping ConfigStrike alive, updated, and servers running takes a lot of time and resources. If you find this tool useful and want to help me continue improving it, consider supporting me on my platforms.",
        es: "Mantener ConfigStrike vivo, actualizado y con los servidores funcionando requiere mucho tiempo y recursos. Si encontrás útil esta herramienta y querés ayudarme a seguir mejorándola, considerá apoyarme en mis plataformas.",
        pt: "Manter o ConfigStrike vivo, atualizado e os servidores funcionando consome muito tempo e recursos. Se você acha esta ferramenta útil e quer me ajudar a continuar melhorando-a, considere me apoiar em minhas plataformas."
    },
    BLOG_SUPPORT_STRONG: {
        en: "Every bit of support makes a huge difference!",
        es: "¡Cada granito de arena hace una diferencia enorme!",
        pt: "Cada pequeno apoio faz uma enorme diferença!"
    },

    // Post: Launch Day
    BLOG_LAUNCH_TITLE: {
        en: "The Journey to ConfigStrike Launch",
        es: "El camino al lanzamiento de ConfigStrike",
        pt: "A Jornada para o Lançamento do ConfigStrike"
    },
    BLOG_LAUNCH_P1: {
        en: "After months of development, ConfigStrike is finally here. What started as a small crosshair preview tool in 2024 has grown into a full-featured configuration suite.",
        es: "Después de meses de desarrollo, ConfigStrike finalmente está aquí. Lo que empezó como una pequeña herramienta de previsualización de miras en 2024 se convirtió en una suite completa de configuración.",
        pt: "Após meses de desenvolvimento, o ConfigStrike finalmente chegou. O que começou como uma pequena ferramenta de prévia de mira em 2024 cresceu e se tornou uma suíte completa de configuração."
    },
    BLOG_LAUNCH_P2: {
        en: "Our goal was to make CS2 configuration accessible for everyone, from beginners to pros. We've built an engine that's fast, visual, and accurate.",
        es: "Nuestro objetivo era hacer que la configuración de CS2 sea accesible para todos, desde principiantes hasta profesionales. Creamos un motor que es rápido, visual y preciso.",
        pt: "Nosso objetivo era tornar a configuração do CS2 acessível para todos, de iniciantes a profissionais. Construímos um motor que é rápido, visual e preciso."
    }
};
